// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/Invoice.yaml
// Generated: 2025-11-16T16:06:52.769Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateInvoice, UpdateInvoice, Invoice } from '@/types/sales/Invoice';

/**
 * Invoice Service
 * CRUD operations for Invoice via the ABP API.
 */
export const invoiceService = new EntityService<Invoice, CreateInvoice, UpdateInvoice>(
  '/api/sales/invoice',
  'Invoice',
);
